import  { useEffect, useState } from 'react';
import {
  Autocomplete,
  TextField,
  IconButton,
  Box,
  Tooltip,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import _ from 'lodash';
import { staticareanames } from '../MapComponents/AreaNames';
import api from '../../router/axiosConfig';

function SearchbyAreaname(props) {
  const {
    locationChange,
    location_submit,
    userselect,
    areatargetsearch,
  } = props;

  const [areaListLocal, setAreaListLocal] = useState([]);
  useEffect(() => {
    const fetchAreaNames = async () => {
      try {
        const response = await api.get('getAreaKeywords');
        const list = _.concat(staticareanames, response.data || []);
        setAreaListLocal(list);
         } catch (error) {
        console.error('Error fetching area names:', error);
      }
    };
    fetchAreaNames();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: 500,
        gap: 1,
      }}
    >
      <Autocomplete
        id="area-autocomplete"
        options={areaListLocal}
        getOptionLabel={(option) => option.add5 || ''}
        isOptionEqualToValue={(option, value) => option.add5 === value.add5}
        inputValue={areatargetsearch}
        onInputChange={(e, newValue) => {
          locationChange({ target: { name: 'location', value: newValue } });
        }}
        onChange={(e, newValue) => {
          if (newValue) {
            userselect({ itemData: newValue }); // Triggers map zoom in parent
          }
        }}
        renderInput={(params) => (
          <TextField {...params} label="Select City/Area" fullWidth   variant="standard"/>
        )}
        sx={{ flexGrow: 1 }}
      />
      <Tooltip title="Click here to view the Vehicles Details">
        <IconButton
          onClick={location_submit}
          size="large"
          color="primary"
          sx={{ ml: 1, backgroundColor: 'white' }}
        >
          <SearchIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
export default SearchbyAreaname;